import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGuirlande = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 426,
	height: 342,
	viewBox: "0 0 426 342",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_dddd_2193_9770)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M341.518 -29.8C341.85 -26.6961 316.695 -22.038 316.747 -18.9424C316.799 -15.8468 342.105 -11.9661 341.87 -8.90469C341.635 -5.84329 316.025 -5.78327 315.51 -2.73018C314.996 0.322918 339.249 8.56685 338.474 11.5788C337.698 14.5907 312.451 10.3057 311.46 13.2367C310.468 16.1677 333.087 28.1536 331.853 31.0106C330.62 33.8677 306.311 25.8328 304.888 28.602C303.464 31.3711 324.183 46.4204 322.588 49.0688C320.993 51.7173 297.926 40.5455 296.174 43.1251C294.422 45.7046 313.1 63.1886 311.203 65.6405C309.305 68.0923 287.723 54.274 285.687 56.6241C283.645 58.9483 300.255 78.4577 298.1 80.6732C295.945 82.8887 275.965 66.8642 273.698 68.971C271.43 71.0778 285.922 92.2102 283.535 94.1824C281.148 96.1546 262.898 78.195 260.425 80.0515C257.952 81.9081 270.254 104.404 267.687 106.119C265.121 107.834 248.741 88.1519 246.114 89.7443C243.486 91.3368 253.55 114.905 250.843 116.408C248.136 117.91 233.432 96.9182 230.672 98.3243C227.911 99.7303 236.287 123.945 233.473 125.254C230.659 126.564 217.397 104.63 214.536 105.869C211.675 107.107 218.588 131.769 215.706 132.93C212.825 134.091 200.767 111.473 197.865 112.557C194.962 113.64 200.684 138.621 197.735 139.633C194.818 140.665 183.69 117.576 180.752 118.53C177.822 119.51 182.649 144.675 179.672 145.584C176.695 146.493 166.264 123.106 163.287 124.015C160.31 124.924 164.579 150.183 161.589 151.04C158.604 151.923 148.56 128.322 145.569 129.179C142.578 130.036 146.582 155.339 143.591 156.196C140.6 157.053 130.659 133.424 127.694 134.274C124.729 135.124 128.732 160.427 125.741 161.284C122.751 162.141 112.661 138.58 109.677 139.462C106.693 140.345 111.041 165.584 108.096 166.512C104.66 167.571 93.0511 144.556 88.7946 145.974C85.1976 147.16 89.6124 172.547 85.558 173.995C81.8852 175.312 69.2321 152.854 65.309 154.377C61.6381 155.805 67.2842 180.918 63.4667 182.524C59.6491 184.13 45.9275 162.347 42.1566 164.024C38.4894 165.673 45.6708 190.402 42.0193 192.213C38.3679 194.024 23.0185 173.316 19.4605 175.269C15.9024 177.222 25.0956 201.273 21.6569 203.361C18.2183 205.448 0.803145 186.46 -2.46943 188.753C-5.85765 191.132 6.27232 213.813 3.20561 216.356C0.1389 218.899 -20.1713 202.991 -22.9405 205.815C-25.8892 208.799 -9.2387 228.353 -11.5601 231.502C-14.0402 234.887 -37.9237 225.433 -39.6003 229.02C-41.2768 232.606 -18.5602 244.233 -19.2741 248.2C-19.988 252.167 -45.2781 255.39 -44.805 259.539C-44.3634 263.363 -18.8993 261.204 -17.3483 265.231C-15.9552 268.772 -36.6739 283.875 -34.3287 287.55",
			stroke: "#DBACF5",
			strokeWidth: 4.10313,
			strokeMiterlimit: 10
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_dddd_2193_9770",
		x: -51.8643,
		y: -39.4963,
		width: 477.787,
		height: 381.15,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 4,
				dy: 2
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.5 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_2193_9770"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 14,
				dy: 7
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 8 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.04 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect1_dropShadow_2193_9770",
				result: "effect2_dropShadow_2193_9770"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 32,
				dy: 16
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10.5 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.03 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect2_dropShadow_2193_9770",
				result: "effect3_dropShadow_2193_9770"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 57,
				dy: 28
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12.5 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect3_dropShadow_2193_9770",
				result: "effect4_dropShadow_2193_9770"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect4_dropShadow_2193_9770",
				result: "shape"
			})
		]
	}) })]
});
export default SvgGuirlande;
